// src/components/LoginForm.js
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { login } from "./auth";
import "./Login.css";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../contexts/AuthProvider";
import { FRONTEND_URL } from "../../utils/config";

function LoginForm({ setIsResetPass, setIsRegister }) {
  const { t } = useTranslation("login");
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [loading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState("");
  const [dirty, setDirty] = useState(false);
  const navigate = useNavigate();

  const authContext = useContext(AuthContext);
  const { setUserName, setIsAuthenticated } = authContext || {};

  const validate = (data) => {
    const errs = {};
    // Basic email validation
    if (!data.email.trim()) {
      errs.email = t("LoginForm.invalidEmail");
    } else if (
      !/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(data.email)
    ) {
      errs.email = t("LoginForm.invalidEmail");
    }
    if (!data.password) {
      errs.password = t("LoginForm.passwordRequired");
    }
    return errs;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDirty(true);
    const newData = { ...formData, [name]: value };
    setFormData(newData);
    setErrors(validate(newData));
  };

  const handleBlur = (e) => {
    const { name } = e.target;
    setTouched((prev) => ({ ...prev, [name]: true }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate(formData);
    setErrors(validationErrors);
    setTouched({ email: true, password: true });
    if (Object.keys(validationErrors).length > 0) {
      return;
    }
    try {
      setLoginError("");
      setLoading(true);
      const response = await login(formData);
      console.log("Login response:", response);
      if (response && response.data) {
        // Save user data in localStorage
        console.log("User data:", response.data);
        localStorage.setItem("user", JSON.stringify(response.data));
        // Update context if available
        if (typeof setUserName === "function") {
          setUserName(`${response.data.firstName} ${response.data.familyName}`);
        }
        // Redirect to dashboard after successful login
        navigate("/dashboard");
      } else {
        setLoginError(t("LoginForm.invalidLoginResponse"));
      }
    } catch (error) {
      console.error("Login error: ", error);
      let errorMessage =
        error?.response?.error ||
        error?.response?.message ||
        t("LoginForm.somethingWentWrong");
      if (typeof errorMessage === "object") {
        errorMessage = errorMessage.message || JSON.stringify(errorMessage);
      }
      setLoginError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleVenuesRedirect = () => {
    window.location.href = `${FRONTEND_URL}/contact`;
  };

  return (
    <form onSubmit={onSubmit} className="login-form">
      <h1 className="title-login-form">{t("LoginForm.title")}</h1>
      <p className="subtitle-login-form">{t("LoginForm.subtitle")}</p>

      <div className="form-group-login">
        <label htmlFor="email">{t("LoginForm.emailLabel")}</label>
        <input
          type="text"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.email && errors.email && (
          <p className="login-error">{errors.email}</p>
        )}
      </div>

      <div className="form-group-login">
        <label htmlFor="password">{t("LoginForm.passwordLabel")}</label>
        <div className="password-input-container">
          <input
            type={formData.passwordVisible ? "text" : "password"}
            id="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          <span
            className="eye-icon"
            onClick={() =>
              setFormData({
                ...formData,
                passwordVisible: !formData.passwordVisible,
              })
            }
          >
            <img
              src={formData.passwordVisible ? "/eye.svg" : "/eye-slash.svg"}
              alt="toggle visibility"
            />
          </span>
        </div>
        {touched.password && errors.password && (
          <p className="login-error">{errors.password}</p>
        )}
      </div>

      {(loginError || Object.keys(errors).length > 0) && (
        <p className="login-error">{loginError}</p>
      )}

      <div className="form-group-login">
        <button
          type="button"
          className="forgot-password"
          onClick={() => setIsResetPass(true)}
        >
          {t("LoginForm.forgotPassword")}
        </button>
      </div>

      <div className="form-group-login">
        <button
          type="submit"
          disabled={loading || Object.keys(errors).length > 0 || !dirty}
          className="login-btn"
        >
          {loading ? t("LoginForm.loggingIn") : t("LoginForm.loginButton")}
        </button>
      </div>

      <div className="form-group-login">
        <button
          className="register-btn"
          type="button"
          onClick={handleVenuesRedirect}
        >
          {t("LoginForm.joinUs")}
        </button>
      </div>
    </form>
  );
}

export default LoginForm;
